// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__rpo_X","label":"Category_label__1qsus","content":"Category_content__azafE","header":"Category_header__2AwQM","location":"Category_location__2l7X8"};